import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Stack, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useFormik } from 'formik';
import ReCAPTCHA from 'react-google-recaptcha';
import axios from 'axios';
import jwtEncode from 'jwt-encode';
import { useGoogleLogin } from '@react-oauth/google';
import { saveUserData } from '../../../store/slice/userSlice';
import { loginValidationSchema } from './validation';
import { WarningIcon } from '../../../SvgIconsData';

const CreateNewPasswordForm = () => {
  const configData = useSelector((state) => state.configSlice);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const recaptchaRef = useRef(null);
  const [verified, setVerified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const [error, setError] = useState(null);

  const [loading, setLoading] = useState(false);

  const location = useLocation();

  const link = new URLSearchParams(location.search).get('link');

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema: loginValidationSchema,
    onSubmit: async (values) => {
      if(!isOnline) {
        setError('Please check your connection and try again.');
        return
      }

      // if(!verified){
      //   setError('Please check the reCAPTCHA.');
      //   return
      // }

        setError(null);
        try {
          const data = {
            password: values.password,
            confirmPassword: values.confirmPassword,
          };
          setLoading(true);
          const response = await axios.post(
            `${configData.config.UNO_URL}/api/auth/createPassword/${configData.config.applicationId}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${link}`,
                'Content-Type ': 'application/json',
              },
            }
          );

          if (response.status === 200) {
            localStorage.setItem('token', link);
            navigate(0);
          }
          setError(error?.response?.data?.message);
          console.log('error');
          setLoading(false);
        } catch (error) {
          setError(error?.response?.data?.message);
          setLoading(false);
        }
        // finally{
        //   setVerified(false);
        //   recaptchaRef.current.reset();
        // }

    },
  });

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        formik.handleSubmit();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  // const handleRecaptchaClick = () => {
  //   setVerified(true);
  // };

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Stack spacing={3}>
          <div className="form-group">
            <div className="d-flex justify-content-between">
              <p className="mb-1"> New Password*</p>
            </div>
            <TextField
              name="password"
              fullWidth
              placeholder="Password"
              size="sm"
              defaultValue={formik.values.password}
              type={showPassword ? 'text' : 'password'}
              onChange={(e) => {
                formik.setFieldValue('password', e.target.value);
                setError(null);
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.password && Boolean(formik.errors.password)}
              autoComplete="off"
            />
            <span className="login-error"> {formik.touched.password && formik.errors.password}</span>
          </div>
          <div className="form-group">
            <div className="d-flex justify-content-between">
              <p className="mb-1">Confirm New Password*</p>
            </div>
            <TextField
              name="password"
              fullWidth
              placeholder="Password"
              size="sm"
              defaultValue={formik.values.confirmPassword}
              type={showPassword ? 'text' : 'password'}
              onChange={(e) => {
                formik.setFieldValue('confirmPassword', e.target.value);
                setError(null);
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.password && Boolean(formik.errors.confirmPassword)}
              autoComplete="off"
            />
          </div>
        </Stack>

        {/* <div className='mt-3' >
          <ReCAPTCHA ref={recaptchaRef} sitekey={configData.config.captcha} onChange={handleRecaptchaClick} />
        </div> */}
        
        <span className="login-error">
          {!(formik.touched.password && formik.errors.confirmPassword) ? error : ''}
        </span>

        <button className="reset-page-btn mt-3" size="large" type="submit" color="secondary">
          {loading ? (
            <>
              <div className="loader-btn">
                <span className="bar" />
                <span className="bar" />
                <span className="bar" />
              </div>
            </>
          ) : (
            <> Create password</>
          )}
        </button>
      </form>

    </>
  );
};

export default CreateNewPasswordForm;
